import { render, staticRenderFns } from "./ColorPanel.vue?vue&type=template&id=451c2ebc&"
import script from "./ColorPanel.vue?vue&type=script&lang=js&"
export * from "./ColorPanel.vue?vue&type=script&lang=js&"
import style0 from "./ColorPanel.vue?vue&type=style&index=0&id=451c2ebc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports